import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import moment from 'moment'

export const getBedbankPriceAndValue =
  (hotelOnlyRates: App.BedbankRate[], showTaxExclusivePrices: boolean, roomId: string | undefined):
  {price?: number, value?: number, isExclusivePrice?: boolean} => {
    const rate = hotelOnlyRates.find(rate => !roomId || rate.roomId === roomId)
    if (!rate) {
      return {}
    }
    const propertyFees = rate.totals.propertyFees ?? 0
    const inclusivePrice = rate.totals.inclusive + propertyFees
    return {
      price: showTaxExclusivePrices ? rate.totals.exclusive : inclusivePrice,
      value: rate.value,
      isExclusivePrice: showTaxExclusivePrices && rate.totals.exclusive !== inclusivePrice,
    }
  }

export function getBedbankFacilitiesLimit(tagline: boolean, promotionsLength: number) {
  let limitNumberOfFacilities = 5
  if (tagline) limitNumberOfFacilities = limitNumberOfFacilities - 3
  if (promotionsLength) limitNumberOfFacilities = Math.round(limitNumberOfFacilities - (promotionsLength * 1.5))
  limitNumberOfFacilities = limitNumberOfFacilities > 0 ? limitNumberOfFacilities : 0

  return limitNumberOfFacilities
}

// Promo utils
export default function getBedbankPromoExtraValue(data: {
  value: number,
  price: number,
  minLos: number,
  duration: number,
}): number {
  return ((data.value - data.price) / data.minLos) * data.duration
}

export const filterPromotionsByTravelPeriod = (promo: App.BedbankPromotion, checkIn: string, checkOut: string) => {
  const travelPeriodFrom = new Date(promo.travelPeriod.from)
  const travelPeriodTo = new Date(promo.travelPeriod.to)
  const checkInDate = new Date(checkIn)
  const checkOutDate = new Date(checkOut)

  return travelPeriodFrom <= checkInDate && travelPeriodTo >= checkInDate && travelPeriodFrom <= checkOutDate && travelPeriodTo >= checkOutDate
}

export const getPromotionDefaultPeriod = () => {
  return {
    startDate: moment().utc().add(1, 'day').format(ISO_DATE_FORMAT),
    endDate: moment().utc().add(500, 'days').format(ISO_DATE_FORMAT),
  }
}
